// services/api/studentService.js
import API from '../api/api';

export const districtService = {
    getDistricts: async () => {
    const response = await API.get('/get_districts');
    return response.data.data || [];
  },
  deleteDistrict: async (id) => {
    const response = await API.post('/delete_district', { id });
    return response.data;
  },
  createDistrict: async (payload) => {
    const response = await API.post('/create_district', payload);
    return response.data;
  },
  
  updateDistrict: async (payload) => {
    const response = await API.post('/update_district', payload);
    return response.data;
  },
};


